export const VOICE_MAX_BYTES = 8 * 1024 * 1024;
export const VOICE_MAX_SECONDS = 180;
export const VOICE_TRANSCRIPT_MAX = 8000;
export function chooseVoiceCodec(supports: (mime: string) => boolean): string {
  return ['audio/mp4', 'audio/webm;codecs=opus', 'audio/webm'].find(supports) ?? '';
}
export function voiceCapReached(seconds: number, bytes: number): boolean {
  return seconds >= VOICE_MAX_SECONDS || bytes >= VOICE_MAX_BYTES;
}
export function elapsedSeconds(start: number, now: number): number {
  return Math.min(VOICE_MAX_SECONDS, Math.max(0, Math.floor((now - start) / 1000)));
}
export function transcriptStatus(text: string, partial: boolean): string {
  return !text.trim()
    ? 'transcript not available'
    : partial
      ? 'Partial transcript, review before sending'
      : 'Transcript';
}
export function voiceDraftExpired(created: number, now: number): boolean {
  return !Number.isFinite(created) || created > now || now - created >= 24 * 60 * 60 * 1000;
}
export function voiceTime(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
}

// Shared mic priority for dictation components mounted midway through capture.
export let voiceCaptureActive = false;
export function setVoiceCaptureActive(active: boolean): void {
  voiceCaptureActive = active;
  window.dispatchEvent(new CustomEvent('console-voice-capture', { detail: active }));
}
